import React, { useRef, useState } from "react";
import { Play } from "lucide-react";

const VIDEO_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_acdt-hub/artifacts/x3qk6oc8_Video%20d%27apertura%20A.C.D.T.%20con%20Slide%20Ufficiali%20%2890-120s%29_1080p.mp4";

/**
 * Player click-to-play del video di presentazione ufficiale A.C.D.T.
 * - Mostra un poster/thumbnail (senza scaricare il video da 188 MB)
 * - Al click, carica e riproduce il video con audio
 */
export default function PresentazioneVideo({
  posterSrc = "/acdt-logo.jpg",
  className = "",
  rounded = "rounded-2xl",
  ariaLabel = "Video di presentazione ufficiale A.C.D.T.",
}) {
  const [started, setStarted] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    setStarted(true);
    // attende il mount del <video> e avvia
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.play().catch(() => {});
      }
    }, 50);
  };

  return (
    <div
      className={`relative overflow-hidden ${rounded} shadow-2xl border border-white/10 bg-black aspect-video ${className}`}
      data-testid="presentazione-video-container"
    >
      {!started ? (
        <button
          type="button"
          onClick={handlePlay}
          aria-label={ariaLabel}
          data-testid="presentazione-video-play-btn"
          className="group absolute inset-0 w-full h-full flex items-center justify-center focus:outline-none"
        >
          {/* Poster */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#0a1f55] via-[#102a6b] to-[#1e3a8a]" />
          <img
            src={posterSrc}
            alt="A.C.D.T. — Presentazione ufficiale"
            className="absolute inset-0 w-full h-full object-contain p-8 opacity-90"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors" />
          {/* Bottone play */}
          <div className="relative z-10 flex flex-col items-center gap-3 pointer-events-none">
            <div className="h-20 w-20 md:h-24 md:w-24 rounded-full bg-[#f59e0b] text-[#0a1f55] flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
              <Play className="h-9 w-9 md:h-11 md:w-11 fill-current ml-1" />
            </div>
            <span className="px-4 py-1.5 rounded-full bg-white/95 text-[#0a1f55] text-xs md:text-sm font-bold tracking-wide">
              Guarda la presentazione ufficiale
            </span>
          </div>
        </button>
      ) : (
        <video
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-contain bg-black"
          controls
          preload="metadata"
          playsInline
          data-testid="presentazione-video-player"
        >
          <source src={VIDEO_URL} type="video/mp4" />
          Il tuo browser non supporta il tag video HTML5.
        </video>
      )}
    </div>
  );
}
